import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

const CategoriesPage = lazy(() => import("@/pages/categories/CategoriesPage"));
const CategoryCreatePage = lazy(() => import("@/pages/categories/CategoryCreatePage"));
const CategoryEditPage = lazy(() => import("@/pages/categories/CategoryEditPage"));

export function CategoryRoutes() {
  return (
    <>
      <Route path="/categories" element={<ProtectedRoute><CategoriesPage /></ProtectedRoute>} />
      <Route path="/categories/new" element={<ProtectedRoute><CategoryCreatePage /></ProtectedRoute>} />
      <Route path="/categories/:id/edit" element={<ProtectedRoute><CategoryEditPage /></ProtectedRoute>} />
    </>
  );
}
